import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AccessGrantsPage = lazy(() => import("@/features/dashboard/pages/access-grants"));

export const Route = createFileRoute("/(app)/ops/access-grants/")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <AccessGrantsPage />
    </Suspense>
  ),
});
